import { createReducer, createActions } from "reduxsauce";
import Immutable from "seamless-immutable";

const { Types, Creators } = createActions({
  leaveRequest: ["leave"],
  leaveSuccess: ["leavedata"],
  leaveFailure: null,
});

export const LeaveTypes = Types;
export default Creators;

export const INITIAL_STATE = Immutable({
  data: null,
  fetching: null,
  success: null,
  leavedata: null,
  error: null,
  leave: null,
});

export const LeaveSelectors = {
  getData: (state: any) => state.leave.data,
  isFetching: (state: any) => state.leave.fetching,
  isSuccess: (state: any) => state.leave.success,
  hasError: (state: any) => state.leave.error,
};

export const request = (state: any, { leave }: any) => {
  const updateData = {
    fetching: true,
    success: false,
    error: false,
    leavedata: null,
    leave: leave,
  };
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

export const success = (state: any, action: any) => {
  const { leavedata } = action;
    const updateData = {
    fetching: false,
    success: true,
    error: false,
    leavedata,
  };
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

export const failure = (state: any) => {
  const updateData = {
    fetching: false,
    success: false,
    error: true,
    leavedata: null,
  };
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

export const reducer = createReducer(INITIAL_STATE, {
  [Types.LEAVE_REQUEST]: request,
  [Types.LEAVE_SUCCESS]: success,
  [Types.LEAVE_FAILURE]: failure,
});
